module.exports = __webpack_public_path__ + "4a99bac56ead4f1c5f1d59c8f602d266.svg";